import React, { useEffect, useState } from "react";
import { leaf, logo, logoBlack, logoWhite, logo_black_bg } from "../../assets";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlinePhone } from "react-icons/hi";
import { RxHamburgerMenu } from "react-icons/rx";
import { CgClose } from "react-icons/cg";
import { FaCircleUser } from "react-icons/fa6";
import { LuLogOut } from "react-icons/lu";
import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiLogoYoutube,
  BiLogoTwitter,
  BiLogoLinkedin,
} from "react-icons/bi";
import {
  BsBookmarkPlus,
  BsFillCaretDownFill,
  BsFillCaretRightFill,
} from "react-icons/bs";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { easeIn, motion } from "framer-motion";
import toast, { Toaster } from "react-hot-toast";

const Navbar = () => {
  const [navClr, setNavClr] = useState(false);
  const [smallDevice, setSmallDevice] = useState(false);
  const [navBG, setNavBG] = useState(false);
  const [navBG1, setNavBG1] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setUserInfo(localStorage.getItem("userInfo"));
  }, []);

  let user;

  if (userInfo) {
    user = JSON.parse(userInfo).username.split(" ")[0];
  }

  const changeNavColor = () => {
    if (window.scrollY >= 80) {
      setNavClr(true);
    } else {
      setNavClr(false);
    }
  };

  window.addEventListener("scroll", changeNavColor);
  return (
    <>
      <div id="navbar">
        <Toaster toastOptions={{ duration: 4000 }} />

        {/* desktop device------------------------------- */}
        <div className={navClr ? "bigDevice navColor" : "bigDevice"}>
          <div className="common">
            <div className="det">
              <div className="time">
                <AiOutlineClockCircle className="clock" />
                <p>09.00 am - 09.00 pm (Everyday)</p>
              </div>
              <div className="call">
                <HiOutlinePhone className="cell" />
                <p>09678006007</p>
              </div>
            </div>
            <div className="social-media">
              <Link to="/https://www.facebook.com/DhakaDermatologyInstitute/">
                <BiLogoFacebook className="socialIO" />
              </Link>
              <Link to="/https://www.instagram.com/dhakadermatologyinstitute/">
                <BiLogoInstagramAlt className="socialIO" />
              </Link>
              <Link to="/https://www.youtube.com/@DhakaDermatologyInstitute">
                <BiLogoYoutube className="socialIO" />
              </Link>
              <Link to="/https://twitter.com/lasertreat">
                <BiLogoTwitter className="socialIO" />
              </Link>
              <Link to="/https://www.linkedin.com/company/laser-treat/?originalSubdomain=bd">
                <BiLogoLinkedin className="socialIO" />
              </Link>
            </div>
          </div>

          <div className="btmPart">
            <div className="mainLogo" onClick={() => navigate("/")}>
              <img src={logoBlack} alt="" />
            </div>
            <div className="menu">
              <NavLink to="/" className="link">
                Home
                <motion.img
                  whileInView={{ opacity: [0, 1], y: [-10, 0] }}
                  transition={{ duration: 0.7 }}
                  src={leaf}
                  alt=""
                  className="leaf"
                />
              </NavLink>
              <NavLink to="/specialist" className="link">
                Specialists
                <motion.img
                  whileInView={{ opacity: [0, 1], y: [-10, 0] }}
                  transition={{ duration: 0.7 }}
                  src={leaf}
                  alt=""
                  className="leaf"
                />
              </NavLink>
              <p className="link d-link">
                <span className="">Treatments</span>
                <BsFillCaretDownFill className="downArrow" />
                <span className="nav-bg">
                  <li>
                    {" "}
                    <Link className="menuLink " to="/asthetic-treatments">
                      <span className="">AESTHETIC</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>{" "}
                  <li>
                    <Link className="menuLink " to="/anti-aging-treatments">
                      <span className="">ANTI-AGING</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/body-shaping-treatments">
                      <span className="">BODY SHAPING</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/dermatology-treatments">
                      <span className="">DERMATOLOGY</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/sexology-treatments">
                      <span className="">SEXOLOGY</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/patient-results">
                      <span className="results">PATIENT RESULTS</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                </span>
              </p>
              <p className="link d-link">
                <span className="">Trainings</span>
                <BsFillCaretDownFill className="downArrow" />
                <span className="nav-bg">
                  <li>
                    <Link className="menuLink " to="/trainings">
                      <span className="">Level 1: Dermatology</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/trainings">
                      <span className="">Level 2: Dermatology</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/trainings">
                      <span className="">Dermatosurgery</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/trainings">
                      <span className="">Masters in Botox</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/trainings">
                      <span className="">Masters in Botox</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/trainings">
                      <span className="">Masters in Filler</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/trainings">
                      <span className="">Breast Augmentation</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/trainings">
                      <span className="">Laser Dermatology</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                  <li>
                    <Link className="menuLink " to="/trainings">
                      <span className="">Masters in MPG</span>
                      <BsFillCaretRightFill className="rightArrow" />
                    </Link>
                  </li>
                </span>
              </p>

              <NavLink to="/videos" className="link">
                Videos
                <motion.img
                  whileInView={{ opacity: [0, 1], y: [-10, 0] }}
                  transition={{ duration: 0.7 }}
                  src={leaf}
                  alt=""
                  className="leaf"
                />
              </NavLink>
              <NavLink to="/blogs" className="link">
                Blogs
                <motion.img
                  whileInView={{ opacity: [0, 1], y: [-10, 0] }}
                  transition={{ duration: 0.7 }}
                  src={leaf}
                  alt=""
                  className="leaf"
                />
              </NavLink>
              <NavLink to="/about-us" className="link">
                About Us
                <motion.img
                  whileInView={{ opacity: [0, 1], y: [-10, 0] }}
                  transition={{ duration: 0.7 }}
                  src={leaf}
                  alt=""
                  className="leaf"
                />
              </NavLink>
              <NavLink to="/contact" className="link">
                Contact
                <motion.img
                  whileInView={{ opacity: [0, 1], y: [-10, 0] }}
                  transition={{ duration: 0.7 }}
                  src={leaf}
                  alt=""
                  className="leaf"
                />
              </NavLink>
              <NavLink to="/locations" className="link">
                Locations
                <motion.img
                  whileInView={{ opacity: [0, 1], y: [-10, 0] }}
                  transition={{ duration: 0.7 }}
                  src={leaf}
                  alt=""
                  className="leaf"
                />
              </NavLink>
            </div>

            <div className="right">
              <button
                className="booking"
                onClick={() => navigate("/appointment")}
              >
                <small>Book Appointment</small>
              </button>
              {userInfo ? (
                <button className="login" onClick={() => navigate("/profile")}>
                  <FaCircleUser className="ico" />
                  <small>{user}</small>
                </button>
              ) : (
                <button className="login" onClick={() => navigate("/login")}>
                  <FaCircleUser className="ico" />
                  <small>Login</small>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* modile device------------------------------- */}
        <div className="smallDevice">
          <div className="content">
            <img
              src={logoWhite}
              alt=""
              className="logo"
              onClick={() => navigate("/")}
            />
            {smallDevice ? (
              <CgClose
                className="closeMenu"
                onClick={() => setSmallDevice(!smallDevice)}
              />
            ) : (
              <RxHamburgerMenu
                className="openMenu"
                onClick={() => setSmallDevice(!smallDevice)}
              />
            )}

            {smallDevice && (
              <motion.div
                className="menuItem"
                whileInView={{ y: [-100, 0], opacity: [0, 1] }}
                transition={{ duration: 0.35, ease: easeIn }}
              >
                <NavLink
                  to="/"
                  className="link"
                  onClick={() => setSmallDevice(false)}
                >
                  Home
                </NavLink>
                <NavLink
                  to="/specialist"
                  className="link"
                  onClick={() => setSmallDevice(false)}
                >
                  Specialists
                </NavLink>
                <p className="link d-link">
                  <div>
                    <span className="" onClick={() => setNavBG(!navBG)}>
                      Treatments
                    </span>
                    <BsFillCaretDownFill className="downArrow" />
                  </div>
                  {navBG && (
                    <ul className="nav-bg">
                      <li>
                        {" "}
                        <Link
                          className="menuLink "
                          to="/asthetic-treatments"
                          onClick={() => setSmallDevice(false)}
                        >
                          <p className="">AESTHETIC</p>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>{" "}
                      <li>
                        <Link
                          className="menuLink "
                          to="/anti-aging-treatments"
                          onClick={() => setSmallDevice(false)}
                        >
                          <p className="">ANTI-AGING</p>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/body-shaping-treatments"
                          onClick={() => setSmallDevice(false)}
                        >
                          <p className="">BODY SHAPING</p>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/dermatology-treatments"
                          onClick={() => setSmallDevice(false)}
                        >
                          <p className="">DERMATOLOGY</p>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/sexology-treatments"
                          onClick={() => setSmallDevice(false)}
                        >
                          <p className="all-course">SEXOLOGY</p>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/patient-results"
                          onClick={() => setSmallDevice(false)}
                        >
                          <p className="all-course">PATIENT RESULTS</p>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                    </ul>
                  )}
                </p>
                <p className="link d-link">
                  <div>
                    <span className="" onClick={() => setNavBG1(!navBG1)}>
                      Trainings
                    </span>
                    <BsFillCaretDownFill className="downArrow" />
                  </div>
                  {navBG1 && (
                    <ul className="nav-bg">
                      <li>
                        <Link
                          className="menuLink "
                          to="/trainings"
                          onClick={() => setSmallDevice(false)}
                        >
                          <span className="">Level 1: Dermatology</span>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/trainings"
                          onClick={() => setSmallDevice(false)}
                        >
                          <span className="">Level 2: Dermatology</span>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/trainings"
                          onClick={() => setSmallDevice(false)}
                        >
                          <span className="">Dermatosurgery</span>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/trainings"
                          onClick={() => setSmallDevice(false)}
                        >
                          <span className="">Masters in Botox</span>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/trainings"
                          onClick={() => setSmallDevice(false)}
                        >
                          <span className="">Masters in Botox</span>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/trainings"
                          onClick={() => setSmallDevice(false)}
                        >
                          <span className="">Masters in Filler</span>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/trainings"
                          onClick={() => setSmallDevice(false)}
                        >
                          <span className="">Breast Augmentation</span>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/trainings"
                          onClick={() => setSmallDevice(false)}
                        >
                          <span className="">Laser Dermatology</span>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="menuLink "
                          to="/trainings"
                          onClick={() => setSmallDevice(false)}
                        >
                          <span className="">Masters in MPG</span>
                          <BsFillCaretRightFill className="rightArrow" />
                        </Link>
                      </li>
                    </ul>
                  )}
                </p>

                <NavLink
                  to="/videos"
                  className="link"
                  onClick={() => setSmallDevice(false)}
                >
                  Videos
                </NavLink>
                <NavLink
                  to="/blogs"
                  className="link"
                  onClick={() => setSmallDevice(false)}
                >
                  Blogs
                </NavLink>
                <NavLink
                  to="/about-us"
                  className="link"
                  onClick={() => setSmallDevice(false)}
                >
                  About Us
                </NavLink>
                <NavLink
                  to="/contact"
                  className="link"
                  onClick={() => setSmallDevice(false)}
                >
                  Contact
                </NavLink>
                <NavLink
                  to="/locations"
                  className="link"
                  onClick={() => setSmallDevice(false)}
                >
                  Locations
                </NavLink>

                <div className="detailsPart">
                  <div className="top">
                    <div className="time">
                      <div>
                        <AiOutlineClockCircle className="clock" />
                        <p>10.00 am - 6.00 pm</p>
                      </div>
                      <small>Everyday</small>
                    </div>

                    <div className="call">
                      <HiOutlinePhone className="cell" />
                      <p>+880 123456789</p>
                    </div>
                  </div>

                  <div className="middle">
                    {userInfo ? (
                      <button
                        onClick={() => {
                          localStorage.clear();
                          window.location.reload(false);
                          toast.success("Logout Successfull!");
                        }}
                        className="locations"
                      >
                        <small>{user}</small>
                        <LuLogOut
                          className="ico"
                          style={{ marginLeft: "0.3rem" }}
                        />
                      </button>
                    ) : (
                      <button
                        className="locations"
                        onClick={() => {
                          navigate("/login");
                          setSmallDevice(false);
                        }}
                      >
                        <FaCircleUser className="ico" />
                        <small>Login</small>
                      </button>
                    )}

                    <button
                      className="booking"
                      onClick={() => {
                        navigate("/appointment");
                        setSmallDevice(false);
                      }}
                    >
                      <small>Book Appointment</small>
                    </button>
                  </div>

                  <div className="mainLogo" onClick={() => navigate("/")}>
                    <img src={logo} alt="" />
                  </div>
                </div>

                <div className="social-media">
                  <Link to="https://www.facebook.com/DhakaDermatologyInstitute/">
                    <BiLogoFacebook className="socialIO" />
                  </Link>
                  <Link to="/https://www.instagram.com/dhakadermatologyinstitute/">
                    <BiLogoInstagramAlt className="socialIO" />
                  </Link>
                  <Link to="/https://www.youtube.com/@DhakaDermatologyInstitute">
                    <BiLogoYoutube className="socialIO" />
                  </Link>
                  <Link to="/https://twitter.com/lasertreat">
                    <BiLogoTwitter className="socialIO" />
                  </Link>
                  <Link to="/https://www.linkedin.com/company/laser-treat/?originalSubdomain=bd">
                    <BiLogoLinkedin className="socialIO" />
                  </Link>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
